import { styled, View } from "@tamagui/core";
import { useContext } from "react";
import { Icon } from "../Icon/Icon.mjs";
import { DEFAULT_SIZE as TEXT_DEFAULT_SIZE, StyleableInternalText, TypographyContext } from "./Typography.Text";
import { jsx, jsxs } from "react/jsx-runtime";
const InternalLink = styled(StyleableInternalText, {
    "$platform-web": {
      display: "inline-flex"
    },
    accessibilityRole: "link",
    alignItems: "center",
    alignSelf: "flex-start",
    bold: !0,
    borderColor: "$transparent",
    borderRadius: "$link.focusRing.radius",
    borderWidth: "$link.focusRing.borderWidth",
    color: "$link-default",
    cursor: "pointer",
    focusable: !0,
    focusVisibleStyle: {
      borderColor: "$link-focused",
      color: "$link-focused",
      outlineStyle: "none"
    },
    group: "link",
    hoverStyle: {
      color: "$link-hovered"
    },
    name: "TypographyLink",
    pressStyle: {
      color: "$link-pressed"
    },
    tag: "a",
    textDecorationLine: "underline",
    variants: {
      disabled: {
        true: {
          color: "$link-disabled",
          cursor: "not-allowed",
          focusable: !1,
          hoverStyle: {
            color: "$link-disabled"
          }
        }
      }
    }
  }),
  LinkIcon = styled(Icon, {
    // groups allow to define a set of styles applied only when the component is inside a specific parent.
    "$group-link": {
      color: "$link-default"
    },
    "$group-link-focus": {
      color: "$link-focused"
    },
    "$group-link-hover": {
      color: "$link-hovered"
    },
    "$group-link-press": {
      color: "$link-pressed"
    },
    marginLeft: "$link.icon.spacing",
    size: "small"
  }),
  mappedTypographySizeToIconSize = {
    large: "regular",
    regular: "small",
    small: "small",
    tiny: 12
  },
  getAndroidOffset = size => {
    switch (size) {
      case "large":
        return 6;
      case "small":
        return 4.5;
      case "tiny":
        return 3.5;
      case "regular":
      default:
        return 4.5;
    }
  };
function Link({
  children,
  forceIcon,
  size,
  ...props
}) {
  const context = useContext(TypographyContext),
    shouldDisplayIcon = forceIcon ?? !context,
    calculatedSize = context?.size || size;
  return /* @__PURE__ */jsxs(InternalLink, {
    size: calculatedSize,
    ...props,
    children: [children, shouldDisplayIcon ? /* @__PURE__ */jsx(View, {
      children: /* @__PURE__ */jsx(LinkIcon, {
        "$platform-android": {
          transform: [{
            translateY: getAndroidOffset(calculatedSize)
          }]
        },
        "$platform-ios": {
          transform: [{
            translateY: context ? -1 : 1.5
          }]
        },
        icon: "link",
        size: mappedTypographySizeToIconSize[calculatedSize || TEXT_DEFAULT_SIZE]
      })
    }) : null]
  });
}
Link.displayName = "Typography.Link";
export { InternalLink, Link };
//# sourceMappingURL=Typography.Link.mjs.map
